import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { ResponsiveIcon } from '../../../icon/responsive';
import Flame from './icon.svg';
import './style.sass';
export const AnimatedFlame = memo(function AnimatedFlame(props) {
    return _jsx(ResponsiveIcon, { Icon: Flame, large: true, ...props });
});
export { Flame };
